import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import ArticleIcon from '@mui/icons-material/Article';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const JustificarAlteracoesNota = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      mt={8}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 'calc(100vh - 140px)',
      }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <IconButton onClick={() => navigate(-1)}>
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    display: { xs: 'none', md: 'flex' },
                    color: '#fff',
                  }}
                />
              </IconButton>

              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Justificar nota
              </span>
            </Grid>

            <span style={{ color: 'white', fontSize: 16 }}></span>
          </Grid>
        </Grid>
      </AppBar>

      <Grid item sm={9} paddingLeft="1rem" paddingRight="1rem" marginTop="2rem">
        <Card
          variant="outlined"
          style={{
            borderTop: `8px solid ${theme.palette.primary.main}`,
          }}
        >
          <CardContent>
            <Typography variant="h6" color="primary">
              Escreva uma justificativa para as alterações realizadas
            </Typography>

            <textarea
              cols="30"
              rows="10"
              placeholder="Digite sua justificativa"
              style={{
                resize: 'none',
                width: '100%',
                marginTop: '2rem',
                borderRadius: '0.2rem',
                border: '1px solid #919191',
              }}
            />
            <Grid container spacing={2}>
              <Grid item sm={6} marginTop="1rem">
                <Button
                  size="large"
                  variant="contained"
                  style={{ width: '100%' }}
                  onClick={() => navigate(-1)}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item sm={6} marginTop="1rem">
                <Button
                  size="large"
                  variant="contained"
                  style={{ width: '100%' }}
                >
                  Enviar
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Box>
  );
};

export default JustificarAlteracoesNota;
